import React, { useEffect, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import StepInfo from './StepsInfo';
import WhatsappSuccess from './Steps/WhatsappSuccess';
import AccountSetup from './Steps/AccountSetup';
import EnableConfigurations from './Steps/EnableConfigurations';

/**
 *
 */
const TallySetup = ({
  user, getTallyConnectionsLoading, getTenantsLoading, history,
}) => {
  const [step, setStep] = useState('');

  useEffect(() => {
    setStep(1);
  }, []);

  return (
    <Fragment>
      <div className="whatsapp-integration-setup">
        <div className="whatsapp-integration__heading">Whatsapp Integration </div>
        <div className="ant-row">
          <div className="ant-col-md-5">
            <StepInfo step={step} loading={getTallyConnectionsLoading || getTenantsLoading} />
          </div>
          {getTallyConnectionsLoading ? (
            <div className="whatsapp-integration__loader__wrapper">

              { [...Array(5).keys()].map((item) => (
                <div key={item} className="whatsapp-integration__loader-row">
                  <div className="loadingBlock  whatsapp-integration__loader__line1" />
                  <div className="loadingBlock  whatsapp-integration__loader__line2" />
                  <div className="loadingBlock  whatsapp-integration__loader__line3" />
                </div>
              ))}
              <div className="loadingBlock whatsapp-integration__loader__line-btn1" />
              <div className="loadingBlock whatsapp-integration__loader__line-btn2" />
            </div>
          )
            : (
              <div className="ant-col-md-19">
                {/* {step === 1 && (<AccountSetup setStep={setStep} />) } */}
                {step === 1 && (<EnableConfigurations setStep={setStep} />)}
                {step === 2 && (<WhatsappSuccess setStep={setStep} />)}
              </div>
            )}

        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,

});

const mapDispatchToProps = (dispatch) => ({
  getTallyConnections: (orgId, callback) => dispatch(TallyIntegrationActions.getTallyConnections(orgId, callback)),
});

TallySetup.propTypes = {
  user: PropTypes.any,
  history: PropTypes.any,
  getTallyConnectionsLoading: PropTypes.bool,
  getTenantsLoading: PropTypes.bool,
  getTallyConnections: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TallySetup));
